import React, { Component } from 'react';
import $ from 'jquery';
import ConfirmModal from '../confirmModal';
import { SERVICE_RESPONSE, Modules } from "../../libs/utils/Const";
import {
    ContentProductTree,
    ContentProductionOrder,
    ContentGoodsReceiptProd,
    ContentGoodsIssue,
    PartnerCreateModal,
    ContentProvConfAssistant,
    SelectionCriteriaModal,
    ContentRscMasterData,
    ContentRscCapacity,
    CentroCosteModal,
} from '../../components';
import '../../css/dataTables.css';
import ItemsListModal from '../ItemsListModal';
import ApiClient from '../../libs/apiClient';
import ListMaterialModal from '../ListMaterialModal';
import UsersModal from '../UsersModal';
import SeriesCreateModal from '../SeriesCreateModal';
import { ProductionLine } from '../NewOrder';
import config from '../../config';
const apiClient = ApiClient.getInstance();
// const Date = new Date();

class NewDocCreateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            pageTotal: 0,
            type: "",
            dataCopy: {},
            partners: [],
            partnerType: null,
            indexPurchaseRequest: null,
            users: [],
            CustomerCode2: false,
            series: [],
            Supplier: false,
            SupplierItem: false,
            itemIndex: null,
            centroCostes: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
        };

        this.refProvConfAssistant = null;
    }

    componentDidMount = () => {
        this._handelBack();
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () {
            window.location.hash = "no-back-button";
        }
    }

    renderTitleModal = () => {
        const { action, view, newOrderModel } = this.props;
        let title = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'productTree':
                title = 'Lista de Materiales';
                break;
            case 'productionOrder':
                title = 'Orden de Fabricación';
                break;
            case 'goodsReceiptProd':
                title = 'Recibo de Producción';
                break;
            case 'goodsIssue':
                title = 'Emisión para Producción';
                break;
            case 'provConfAssistant':
                title = 'Asistente de confirmación de aprovisionamiento';
                break;
            case 'rscMasterData':
                title = 'Datos maestros del recurso';
                break;
            case 'rscCapacity':
                title = 'Capacidad de recursos';
                break;
            default:
        }

        if (action === 1) {
            title = 'Nuevo(a) ' + title;
        }

        if (action === 2) {
            title = 'Detalle de ' + title;
        }

        return title;
    };

    closeModalCreate = async () => {
        const { action, CloseDocumentModal, view, selectTable, searchDocuments } = this.props;
        const ref = this.refProvConfAssistant?.state;

        if (action === 1 && !ref?.creationFlag) {
            $('#confirmModal').modal('show');
        } else {
            $('#DocumentCreateModal').modal('hide');
            await CloseDocumentModal();
            if (view === 'provConfAssistant') {
                const table = selectTable(ref?.docVals.find(doc => doc.Value === ref?.destDocValue)?.View)?.name;
                await searchDocuments(table, 'close');
            }
        }
    };

    cancelEditMode = () => {
        const { refreshModel, setEditMode } = this.props;
        refreshModel(this.state.dataCopy)
        setEditMode(false)
        this.setState({
            dataCopy: {},
        });
        this.forceUpdate()
    };

    editMode = () => {
        const { newOrderModel, setEditMode, editMode, refreshModel, view, wareHouses } = this.props
        const dataCopy = JSON.parse(JSON.stringify(newOrderModel));

        if (view === 'productionOrder') {
            const { _user } = this.state;
            const auxModel = { ...newOrderModel };
            //#region Default Warehouse Determination
            const OnlyView = auxModel?.OnlyView ?? false;
            if (!OnlyView) {
                const U_FMB_WHS_TYPE = Number(_user?.Branch?.AccountDefault?.[0]?.U_FMB_WHS_TYPE ?? 0);
                const availableWhs = _user?.Branch?.AvailableWhs ?? [];
                const availableSet = new Set(availableWhs?.map(a => a.WhsCode));
                const whsMap = new Map((wareHouses ?? [])?.map(w => [w.WhsCode, w]));

                if (auxModel?.Warehouse) { // Validar almacén cabecera que sea de producto terminado
                    const allowedTypes = [
                        '008', // PT
                    ]
                    const whs = whsMap.get(auxModel?.Warehouse);
                    const baseCondition = whs.Inactive === 'N' && allowedTypes?.includes(whs?.U_RS_TipoAlmacen ?? '');

                    const warehouseValid =
                        baseCondition &&
                        (
                            U_FMB_WHS_TYPE === 3 || // Maestra ve todos los PT
                            availableSet.has(whs.WhsCode) // NO maestra ve los PT configurados
                        );

                    auxModel.Warehouse = warehouseValid ? whs.WhsCode : '';

                    //#region Determinar almacén cabecera si no existe
                    if (!auxModel.Warehouse) { // Si no existe revisar cual pudiera ser el default
                        const whsOptions = wareHouses
                            ? wareHouses?.filter(whs => {
                                const baseCondition =
                                    whs.Inactive === 'N' // No sea inactivo
                                    && whs?.U_RS_TipoAlmacen === '008'; // Solo Producto terminado

                                if (!baseCondition) return false;

                                if (Number(U_FMB_WHS_TYPE) === 3) return true; // Si es maestra no validar los almacenes configurados
                                return availableWhs?.some(a => a.WhsCode === whs.WhsCode); // Si NO es maestra validar que exista en los almacenes cofigurados
                            })
                                .map(whs => whs.WhsCode)
                            : [];

                        if (whsOptions?.length === 1) {
                            auxModel.Warehouse = whsOptions?.[0] ?? '';
                        } else {
                            auxModel.Warehouse = '';
                        }
                    }
                    //#endregion Determinar almacén cabecera si no existe
                }

                for (const line of auxModel?.ProductionOrderLines) {
                    const allowedTypes =
                        (Number(line?.ItemType ?? 4) === 4 ||
                            Number(line?.ItemType ?? 4) === 290) ?
                            [
                                '003', // CILINDROS
                                '004', // INSUMOS
                                '099', // GLP
                                '008', // PT
                            ]
                            : null;
                    const whs = whsMap.get(line.Warehouse);

                    if (!whs) {
                        line.Warehouse = '';
                    } else {
                        const baseCondition =
                            whs.Inactive === 'N' &&
                            (
                                !allowedTypes ||
                                allowedTypes?.includes(whs?.U_RS_TipoAlmacen ?? '')
                            );

                        const warehouseValid =
                            baseCondition &&
                            (
                                U_FMB_WHS_TYPE === 3 ||
                                availableSet.has(whs.WhsCode)
                            );

                        // Validar que coincida con el almacén seleccionado en cabecera
                        const headerWhs = String(auxModel.Warehouse ?? '');
                        const lineWhs = String(whs.WhsCode);

                        const first3Match = headerWhs?.substring(0, 3) === lineWhs?.substring(0, 3);
                        const first2Match = headerWhs?.substring(0, 2) === lineWhs?.substring(0, 2);

                        const prefixValid = first3Match || first2Match;

                        line.Warehouse = (warehouseValid && prefixValid)
                            ? whs.WhsCode
                            : '';
                    }
                }
            }
            //#endregion Default Warehouse Determination
            if (_user?.USER_CODE) {
                if (!auxModel?.UserSelected) {
                    auxModel.UserSelected = {};
                }
                if (!auxModel?.UserSelected?.U_NAME) {
                    auxModel.UserSelected.U_NAME = _user?.USER_CODE || '';
                }
                refreshModel(auxModel);
            }
        }

        setEditMode(!editMode)
        this.setState({
            dataCopy,

        });
        this.forceUpdate()
    };

    renderOptions = () => {
        const { action, writeAccess, editMode, view } = this.props;

        if (view !== 'goodsReceiptProd' && view !== 'goodsIssue' && action === 2 && !editMode && writeAccess) {
            return (
                <div>
                    <button
                        type="button"
                        style={{ backgroundColor: 'transparent', color: '#000' }}
                        className="btn btn-editar"
                        onClick={() => this.editMode()}>
                        <i className="fas fa-edit  fa-lg" />
                        Editar
                    </button>
                </div>
            );
        } else {
            return (
                <div>
                </div>
            )
        }

    }

    renderContentColumnCreate = () => {
        const { view, newOrderModel } = this.props;
        const content = 'header';
        let header = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'productTree':
                header = this.renderContentProductTree(content);
                break;
            case 'productionOrder':
                header = this.renderContentProductionOrder(content);
                break;
            case 'goodsReceiptProd':
                header = this.renderContentGoodsReceiptProd(content);
                break;
            case 'goodsIssue':
                header = this.renderContentGoodsIssue(content);
                break;
            case 'provConfAssistant':
                header = this.renderContentProvConfAssistant(content);
                break;
            case 'rscMasterData':
                header = this.renderContentRscMasterData(content);
                break;
            case 'rscCapacity':
                header = this.renderContentRscCapacity(content);
                break;
            default:
        }

        return header;
    };

    renderPartidasColumnCreate = () => {
        const { view, newOrderModel } = this.props;
        const content = 'body';
        let body = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'productTree':
                body = this.renderContentProductTree(content);
                break;
            case 'productionOrder':
                body = this.renderContentProductionOrder(content);
                break;
            case 'goodsReceiptProd':
                body = this.renderContentGoodsReceiptProd(content);
                break;
            case 'goodsIssue':
                body = this.renderContentGoodsIssue(content);
                break;
            case 'provConfAssistant':
                // body = this.renderContentProvConfAssistant(content);
                break;
            case 'rscMasterData':
                body = this.renderContentRscMasterData(content);
                break;
            case 'rscCapacity':
                body = this.renderContentRscCapacity(content);
                break;
            default:
        }

        return body;
    };

    renderContentColumnTwoCreate = () => {
        const { view, newOrderModel } = this.props;
        const content = 'footer';
        let footer = '';

        switch (newOrderModel.OriginDocumentCreate) {
            case 'productTree':
                footer = this.renderContentProductTree(content);
                break;
            case 'productionOrder':
                footer = this.renderContentProductionOrder(content);
                break;
            case 'goodsReceiptProd':
                footer = this.renderContentGoodsReceiptProd(content);
                break;
            case 'goodsIssue':
                footer = this.renderContentGoodsIssue(content);
                break;
            case 'provConfAssistant':
                // footer = this.renderContentProvConfAssistant(content);
                break;
            case 'rscMasterData':
                footer = this.renderContentRscMasterData(content);
                break;
            case 'rscCapacity':
                footer = this.renderContentRscCapacity(content);
                break;
            default:
        }

        return footer;
    };

    openAction = () => {
        $('#DocumentCreateModal').on('hide.bs.modal', function () { });
    };

    restartTabs = () => {
        $('#nav-profile-tab-Contenido-D').removeClass('active');
        $('#dataContenidoDocument').removeClass('active');
        $('#dataContenidoDocument').removeClass('show');
        $('#nav-profile-tab-Contenido-D').addClass('active');
        $('#dataContenidoDocument').addClass('active')
        $('#dataContenidoDocument').addClass('show')
    };

    renderContentProductTree = (render) => {
        const { newOrderModel, action, enableSpinner, listPrice, wareHouses, refreshModel, showAlert, editMode, projects } = this.props;
        return (
            <>
                <ContentProductTree
                    render={render}
                    newOrderModel={newOrderModel}
                    action={action}
                    enableSpinner={enableSpinner}
                    wareHouses={wareHouses}
                    listPrice={listPrice}
                    refreshModel={refreshModel}
                    openItems={this.openItems}
                    editMode={editMode}
                    showAlert={showAlert}
                    projects={projects}
                    openCentroCoste={this.openCentroCoste}
                />
            </>
        );
    }

    renderContentProductionOrder = (render) => {
        const { newOrderModel, action, enableSpinner, refreshModel, wareHouses, listProjects, editMode, showAlert } = this.props;
        return (
            <ContentProductionOrder
                render={render}
                newOrderModel={newOrderModel}
                action={action}
                enableSpinner={enableSpinner}
                openListMaterial={this.openListMaterial}
                refreshModel={refreshModel}
                wareHouses={wareHouses}
                listProjects={listProjects}
                openPartner={this.openPartner}
                openPersonRequest={this.openPersonRequest}
                editMode={editMode}
                openItems={this.openItems}
                openSeries={this.openSeries}
                openCentroCoste={this.openCentroCoste}
                showAlert={showAlert}
            />
        );
    }

    renderContentGoodsReceiptProd = (render) => {
        const { newOrderModel, action, enableSpinner, refreshModel } = this.props;
        return (
            <>
                <ContentGoodsReceiptProd
                    render={render}
                    newOrderModel={newOrderModel}
                    action={action}
                    enableSpinner={enableSpinner}
                    editMode={this.state.editMode}
                    RefreshModel={refreshModel}
                    EnableEditMode={this.editMode}
                    CancelEditMode={this.cancelEditMode}
                    openSeries={this.openSeries}
                    openCentroCoste={this.openCentroCoste}
                />
            </>
        );
    }

    renderContentGoodsIssue = (render) => {
        const { newOrderModel, action, enableSpinner, refreshModel, editMode } = this.props;
        return (
            <ContentGoodsIssue
                render={render}
                newOrderModel={newOrderModel}
                action={action}
                enableSpinner={enableSpinner}
                editMode={editMode}
                RefreshModel={refreshModel}
                EnableEditMode={this.editMode}
                CancelEditMode={this.cancelEditMode}
                openSeries={this.openSeries}
                openCentroCoste={this.openCentroCoste}
            />
        );
    }

    renderContentProvConfAssistant = (render) => {
        const { newOrderModel, enableSpinner, showAlert, selectTable, refreshModel } = this.props;
        return (
            <ContentProvConfAssistant
                render={render}
                newOrderModel={newOrderModel}
                enableSpinner={enableSpinner}
                ref={(ref) => this.refProvConfAssistant = ref}
                openSelectionCriteriaModal={this.openSelectionCriteriaModal}
                showAlert={showAlert}
                selectTable={selectTable}
                openPartner={this.openPartner}
                refreshModel={refreshModel}
            />
        );
    }

    setItemSelectProductionOrder = async itemsSelected => {
        const { type } = this.state
        const { newOrderModel, refreshModel } = this.props
        const auxModel = { ...newOrderModel }
        if (type === 'lines') {
            if ((auxModel?.ListMaterialCopy?.ProductTreeLines?.length ?? 0) == 0) {
                let response = await apiClient.getKitDetails(newOrderModel.ItemNo);
                if (response.status === SERVICE_RESPONSE.SUCCESS) {
                    auxModel.ListMaterialCopy = response?.data ?? null
                }
            }
            const items = auxModel.ProductionOrderLines.slice()
            for (let index = 0; index < itemsSelected.length; index++) {
                const item = itemsSelected[index];
                const findKitLine = auxModel?.ListMaterialCopy?.ProductTreeLines?.find(itm => itm.Code === item.ItemCode)
                let Quantity = Number(findKitLine?.Quantity ?? 1)
                Quantity = isNaN(Quantity) ? 1 : Quantity
                // if (!findItem) {
                let auxItem = {
                    ItemNo: item.ItemCode,
                    ItemName: item.ItemName,
                    BaseQuantity: Quantity,
                    BaseQuantityCopy: Quantity,
                    PlannedQuantity: (newOrderModel?.PlannedQuantity ?? 0) * (Quantity),
                    Available: item.OnHand,
                    Warehouse: item.Warehouse,
                    IsNew: true,
                    Uom: item.InventoryUOM || '',
                    ProductionOrderIssueType: 'im_Backflush',
                }
                auxItem.ItemType = newOrderModel.ItemTypeSearch ?? '4';
                items.push(auxItem)
                // }
            }

            auxModel.ProductionOrderLines = items
        }
        refreshModel(auxModel)

    }

    setItemSelect = async itemsSelected => {
        const { type } = this.state;
        const { newOrderModel, refreshModel, openDocumentDetails, wareHouses = [] } = this.props;
        const auxModel = { ...newOrderModel };
        if (type === 'head') {
            auxModel.TreeCode = itemsSelected[0].ItemCode
            auxModel.Desc = itemsSelected[0].ItemName
            auxModel.IsTreeType = itemsSelected[0].IsTreeType
            auxModel.Quantity = 1
            auxModel.InvntItem = itemsSelected[0].InvntItem
            auxModel.PrchseItem = itemsSelected[0].PrchseItem
            auxModel.SellItem = itemsSelected[0].SellItem
            if (auxModel.IsTreeType !== 'N') {
                openDocumentDetails(auxModel)
                return
            }


        } else if (type === 'lines') {
            const items = auxModel.ProductTreeLines.slice()
            for (let index = 0; index < itemsSelected.length; index++) {
                const item = itemsSelected[index];

                if (Number(item?.ItemType ?? 4) == -18) {
                    item.Quantity = 1
                    item.IsNew = true
                    items.push(item)
                } else {
                    item.ItemType = Number(newOrderModel?.ItemTypeSearch ?? 4);
                    item.IssueMethod = item.IssueMethod || 'B';
                    const findItem = null// items.find(itm => itm.ItemCode === item.ItemCode)
                    if (!findItem) {
                        item.Warehouse = auxModel.Warehouse || '';
                        //#region DIMENSIONS
                        if (Modules.CostCenter && item.Warehouse) {
                            let warehouse = wareHouses?.find(whs => whs.WhsCode === item.Warehouse) ?? {};
                            item.OcrCode2 = warehouse?.U_LLG_DIME2 || ''; // Determinado desde el almacén
                            item.OcrCode3 = warehouse?.U_LLG_DIME3 || ''; // Determinado desde el almacén
                            item.Dimension2 = item.OcrCode2 ? true : false;
                            item.Dimension3 = item.OcrCode3 ? true : false;
                        }
                        //#endregion DIMENSIONS
                        item.Quantity = 1
                        item.IsNew = true
                        items.push(item)
                    }
                }

            }

            auxModel.ProductTreeLines = items
        }

        refreshModel(auxModel)
    }
    selectItems = async itemsSelected => {
        const { view } = this.props;
        switch (view) {
            case 'productTree':
                const { refreshModel, newOrderModel, enableSpinner } = this.props;
                const auxModel = { ...newOrderModel }

                enableSpinner(true);
                auxModel.searchItemMaterial = "";
                await refreshModel(auxModel);
                await this.setItemSelect(itemsSelected)
                enableSpinner(false);
                break;
            case 'productionOrder':
                this.setItemSelectProductionOrder(itemsSelected)
                break;

            default:
                break;
        }
    }

    selectListMaterial = async listMaterialSelected => {
        const { refreshModel, newOrderModel, enableSpinner, wareHouses } = this.props;
        const { _user } = this.state;
        const auxModel = { ...newOrderModel };
        auxModel.ItemNo = listMaterialSelected?.[0]?.Code || '';
        auxModel.ItemName = listMaterialSelected?.[0]?.ItemName || '';
        auxModel.PlannedQuantity = listMaterialSelected?.[0]?.Qauntity || listMaterialSelected?.[0]?.Quantity || 1;
        auxModel.Uom = listMaterialSelected?.[0]?.InvntryUom;
        enableSpinner(true)
        let response = await apiClient.getKitDetails(auxModel.ItemNo);
        const kitLines = [];
        const issueType = {
            'M': 'im_Manual',
            'B': 'im_Backflush'
        };

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            const header = response.data ?? {};
            auxModel.Project = header?.Project ?? null;

            const lines = header?.ProductTreeLines ?? [];

            const U_FMB_WHS_TYPE = Number(_user?.Branch?.AccountDefault?.[0]?.U_FMB_WHS_TYPE ?? 0);
            const availableWhs = _user?.Branch?.AvailableWhs ?? [];
            const availableSet = new Set(availableWhs?.map(a => a.WhsCode));
            const whsMap = new Map((wareHouses ?? [])?.map(w => [w.WhsCode, w]));

            //#region Determinar almacén cabecera si no existe
            let headerWhs = auxModel?.Warehouse ?? '';

            if (!headerWhs) {
                const whsOptions = wareHouses
                    ? wareHouses?.filter(whs => {
                        const baseCondition =
                            whs.Inactive === 'N' // No sea inactivo
                            && whs?.U_RS_TipoAlmacen === '008'; // Solo Producto terminado

                        if (!baseCondition) return false;

                        if (Number(U_FMB_WHS_TYPE) === 3) return true; // Si es maestra no validar los almacenes configurados
                        return availableWhs?.some(a => a.WhsCode === whs.WhsCode); // Si NO es maestra validar que exista en los almacenes cofigurados
                    })?.map(whs => whs.WhsCode)
                    : [];

                if (whsOptions?.length === 1) {
                    headerWhs = whsOptions?.[0] ?? '';
                    auxModel.Warehouse = headerWhs;
                } else {
                    headerWhs = '';
                    auxModel.Warehouse = '';
                }
            }
            //#endregion Determinar almacén cabecera si no existe

            for (let index = 0; index < lines?.length; index++) {
                const line = lines[index];
                const aux = new ProductionLine();
                aux.ItemType = line.ItemType || line.Type;
                aux.ItemNo = line.Code;
                aux.ItemName = line.ItemName;
                aux.BaseQuantity = line.Quantity;
                aux.BaseQuantityCopy = line.Quantity;
                aux.PlannedQuantity = line.Quantity;
                // aux.Warehouse = line.Warehouse;
                aux.OnHand = line.OnHand;
                aux.Available = line.Available;
                aux.Uom = line.InvntryUom;
                aux.LineText = line.LineText;
                aux.ProductionOrderIssueType = issueType[line.IssueType || line.IssueMthd];
                aux.isStatic = line.isStatic ?? null;
                aux.OcrCode = line?.OcrCode ?? '';
                aux.OcrCode2 = line?.OcrCode2 ?? '';
                aux.OcrCode3 = line?.OcrCode3 ?? '';
                aux.OcrCode4 = line?.OcrCode4 ?? '';
                aux.OcrCode5 = line?.OcrCode5 ?? '';

                //#region Default Warehouse Determination
                const allowedTypes =
                    (Number(aux.ItemType ?? 4) === 4 ||
                        Number(aux.ItemType ?? 4) === 290) ?
                        [
                            '003', // CILINDROS
                            '004', // INSUMOS
                            '099', // GLP
                            '008', // PT
                        ]
                        : null;
                const whs = whsMap.get(line.Warehouse);

                if (!whs) {
                    aux.Warehouse = '';
                } else {
                    const baseCondition =
                        whs.Inactive === 'N' &&
                        (
                            !allowedTypes ||
                            allowedTypes?.includes(whs?.U_RS_TipoAlmacen ?? '')
                        );

                    const warehouseValid =
                        baseCondition &&
                        (
                            U_FMB_WHS_TYPE === 3 ||
                            availableSet.has(whs.WhsCode)
                        );

                    //#region Validar que pertenezca al almacén cabecera
                    const lineWhs = String(whs.WhsCode ?? '');

                    const first3Match = headerWhs?.substring(0, 3) === lineWhs?.substring(0, 3);
                    const first2Match = headerWhs?.substring(0, 2) === lineWhs?.substring(0, 2);

                    const prefixValid = headerWhs
                        ? (first3Match || first2Match)
                        : false;

                    aux.Warehouse = (warehouseValid && prefixValid)
                        ? whs.WhsCode
                        : '';
                    //#endregion Validar que pertenezca al almacén cabecera
                }
                //#endregion Default Warehouse Determination
                kitLines.push(aux);
            }
        }
        auxModel.ProductionOrderLines = kitLines;
        enableSpinner(false)
        refreshModel(auxModel)
    }

    refreshItems = async (item, totalRows) => {
        this.setState({
            items: item,
            pageTotal: totalRows
        });
    }

    selectSocio = async partner => {
        const { newOrderModel, refreshModel } = this.props;
        const { CustomerCode2, Supplier, SupplierItem, itemIndex } = this.state;
        const auxModel = { ...newOrderModel };
        const ref = this.refProvConfAssistant;
        let updatedDocumentsLines = Array.isArray(ref?.state?.documentsLines) ? [...ref.state.documentsLines] : [];
        if (CustomerCode2) {
            auxModel.Client2 = partner;
            auxModel.CustomerCode2 = partner.CardCode;
            this.setState({ CustomerCode2: false });
        } else if (Supplier) {
            auxModel.Supplier = partner;
            auxModel.SupplierCode = partner.CardCode;
            updatedDocumentsLines = updatedDocumentsLines.map(line => ({ ...line, CardCode: partner.CardCode }));
            this.setState({ Supplier: false });
        } else if (SupplierItem) {
            updatedDocumentsLines[itemIndex] = { ...updatedDocumentsLines[itemIndex], CardCode: partner.CardCode };
            this.setState({ SupplierItem: false });
        } else {
            auxModel.Client = partner;
            auxModel.CustomerCode = partner.CardCode;
        }

        if (Supplier || SupplierItem) ref.setState({ documentsLines: updatedDocumentsLines });

        refreshModel(auxModel);
        this.setState({
            partners: [],
            pageTotal: 0
        });
    }

    selectPartner = async (action, newIndex = null) => {
        const { partners } = this.state
        this.selectSocio(partners[action.index])
        $('#partnerCreate').modal('hide');
    }
    refreshPartner = async (partner, totalPage) => {
        this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    }

    openListMaterial = async () => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        enableSpinner(true);
        let getListResponse = await apiClient.getListMaterial(newOrderModel.ItemNo || '', view, 0);
        enableSpinner(false);
        if (getListResponse.data.length === 0) {

            if (!Array.isArray(getListResponse.data.results)) {
                showAlert({ type: 'info', message: getListResponse.message });
                return;
            }

            if (getListResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getListResponse.data.results.length === 1) {

            await this.selectListMaterial(getListResponse.data.results);
        } else {
            this.setState({
                items: getListResponse.data.results,
                pageTotal: getListResponse.data.totalPage,
            });
            $('#ListMaterialModal').modal('show');
        }
    }

    openPartner = async (index = null, CustomerCodeCase = '') => {
        const { enableSpinner, showAlert } = this.props;
        const values = this.valuesForParter(index, CustomerCodeCase);
        const type = values.type;
        const CustomerCode = values.CustomerCode;

        enableSpinner(true);
        let getPartnerResponse = await apiClient.getPartner(type, CustomerCode || null);
        enableSpinner(false);

        if (getPartnerResponse.status === 0) {
            if (!Array.isArray(getPartnerResponse.data.results)) {
                showAlert({ type: 'info', message: getPartnerResponse.message });
                return;
            }
            if (getPartnerResponse.data.results.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getPartnerResponse.data.length === 1) {
            const partner = getPartnerResponse.data[0];

            if (partner?.validFor === 'N' || partner?.frozenFor === 'Y') {
                showAlert({ type: 'error', message: 'El socio de negocio se encuentra inactivo' });
                // this.clearSocio();
                return;
            }

            this.setState({
                partners: getPartnerResponse.data,
                partnerType: type
            });


            this.selectSocio(getPartnerResponse.data[0]);
        } else {
            this.setState({
                partners: getPartnerResponse.data.results,
                partnerType: type,
                pageTotal: getPartnerResponse.data.totalPage,
                indexPurchaseRequest: index,
            });
            $('#partnerCreate').modal('show');
        }
    };

    valuesForParter = (index = null, CustomerCodeCase = '') => {
        const { newOrderModel, view } = this.props;
        let CustomerCode2 = false, Supplier = false, SupplierItem = false;
        let type = 'C', CustomerCode = '';

        if (view === 'provConfAssistant') type = 'CL';

        switch (CustomerCodeCase) {
            case 'CustomerCode2':
                CustomerCode2 = true;
                CustomerCode = newOrderModel.CustomerCode2;
                break;
            case 'Supplier':
                type = 'S';
                Supplier = true;
                CustomerCode = newOrderModel.SupplierCode;
                break;
            case 'SupplierItem':
                type = 'S';
                SupplierItem = true;
                const documentsLines = this.refProvConfAssistant.state.documentsLines;
                CustomerCode = documentsLines[index].CardCode;
                break;
            default:
                CustomerCode = newOrderModel.CustomerCode;
                break;
        }

        this.setState({ CustomerCode2, Supplier, SupplierItem, itemIndex: index });

        return { type, CustomerCode };
    }

    selectSeries = action => {
        const { newOrderModel, refreshModel } = this.props;
        let serie = newOrderModel.SerieArray[action.index];
        newOrderModel.SerieName = serie.SeriesName || '';
        newOrderModel.SerieCode = serie.Series || '';
        newOrderModel.NextFolio = serie.NextNumber || '';


        refreshModel(newOrderModel);
        $('#seriesDocumentsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                series: [],
            });
        }, 100);
    };

    openSeries = async () => {
        const { newOrderModel, showAlert } = this.props;
        if (newOrderModel.SerieArray.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        setTimeout(() => {
            this.setState({
                series: newOrderModel.SerieArray,
            });
            $('#seriesDocumentsModal').modal('show');
        }, 100);
    };

    openItems = async (type = 'head') => {
        const { showAlert, newOrderModel, enableSpinner, view } = this.props;
        if ((Number(newOrderModel.ItemTypeSearch ?? '4')) === -18) {
            this.setState({
                type
            });
            const textItem = [{
                LineText: newOrderModel?.searchItemMaterial,
                ItemType: -18
            }]
            if ((newOrderModel?.searchItemMaterial ?? '') == '') {
                return showAlert({ type: 'info', message: 'Agrega una descripción' });
            }

            await this.selectItems(textItem);
        } else {
            enableSpinner(true);
            let getItemResponse = await apiClient.getListItems(type === 'head' ? newOrderModel.TreeCode : newOrderModel.searchItemMaterial || '', view, 0, Number(newOrderModel?.ItemTypeSearch ?? 4));
            enableSpinner(false);

            if (getItemResponse.data.length === 0) {

                if (!Array.isArray(getItemResponse.data.results)) {
                    showAlert({ type: 'info', message: getItemResponse.message });
                    return;
                }

                if (getItemResponse.data.length === 0) {
                    showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                    return;
                }
            }

            if (getItemResponse.data.results.length === 1) {
                this.setState({
                    type
                });
                await this.selectItems(getItemResponse.data.results);
            } else {
                this.setState({
                    items: getItemResponse.data.results,
                    pageTotal: getItemResponse.data.totalPage,
                    type
                });
                $('#itemsListModal').modal('show');
            }
        }

    }

    openPersonRequest = async () => {
        const { enableSpinner, showAlert } = this.props;

        enableSpinner(true);
        let serviceResponse = await apiClient.getUsersList();
        enableSpinner(false);


        if (!Array.isArray(serviceResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (serviceResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            users: serviceResponse.data
        })
        $('#usersModal').modal('show');
    };
    selectUser = async action => {
        $('#usersModal').modal('hide');
        const { users } = this.state
        const { newOrderModel, refreshModel } = this.props
        const auxModel = { ...newOrderModel }
        auxModel.UserSelected = users[action.index]
        auxModel.UserSignature = users[action.index].USERID
        refreshModel(auxModel)
        this.setState({
            users: [],
        })
    }

    validateStrings = text => {
        if (text === '' || text === null || text === undefined) {
            return false
        } else {
            return true
        }
    }

    validateList = () => {
        const { newOrderModel, showAlert, view, wareHouses = [] } = this.props

        if (newOrderModel.OriginDocumentCreate === 'productTree') {
            if (!this.validateStrings(newOrderModel.TreeCode)) {
                showAlert({ type: 'error', message: 'AGREGUE UN NÚMERO DE PRODUCTO' });
                return false
            }
            if (newOrderModel.ProductTreeLines.length === 0) {
                showAlert({ type: 'error', message: 'LA LISTA DE MATERIALES NO PUEDE ESTAR VACÍA' });
                return false
            }
        }
        if (newOrderModel.OriginDocumentCreate === 'productionOrder') {
            if (!this.validateStrings(newOrderModel.ItemNo)) {
                showAlert({ type: 'error', message: 'AGREGUE UN NÚMERO DE PRODUCTO' });
                return false;
            }
            if (newOrderModel.ProductionOrderLines.length === 0) {
                showAlert({ type: 'error', message: 'LINEAS VACÍAS' });
                return false;
            }
            if (!newOrderModel?.SerieCode) {
                showAlert({ type: 'warning', message: 'SELECCIONE UNA SERIE', timeOut: 5000 });
                return false;
            }
            if (!newOrderModel?.Warehouse) {
                showAlert({ type: 'warning', message: 'DEBE SELECCIONAR UN ALMACÉN DE PRODUCTO TERMINADO', timeOut: 5000 });
                return false;
            }
            if (newOrderModel.ProductionOrderStatus === 'R') {
                if (!Number(newOrderModel?.U_RS_CANT ?? 0) || Number(newOrderModel?.U_RS_CANT ?? 0) <= 0) {
                    showAlert({ type: 'warning', message: 'La "Cantidad a liberar" debe de ser mayor a 0', timeOut: 5000 });
                    return false;
                }
                if (Number(newOrderModel?.PlannedQuantity ?? 0) !== Number(newOrderModel?.U_RS_CANT ?? 0)) {
                    showAlert({ type: 'warning', message: 'La "Cantidad Planf." y la "Cantidad a liberar" deben de ser iguales', timeOut: 5000 });
                    return false;
                }
            }

            //#region Validar Almacenes a nivel línea
            let validWhs = true;
            for (const line of newOrderModel?.ProductionOrderLines) {
                if (Number(line?.ItemType ?? 4) !== -18 && !line.Warehouse) {
                    const type = Number(line.ItemType ?? 4) === 4 ? 'artículo' : 'recurso';
                    showAlert({ type: 'warning', message: `Es necesario seleccionar un almacén para el ${type} ${line?.ItemNo ?? line?.ItemName}`, timeOut: 5000 });
                    validWhs = false;
                }
            }
            if (!validWhs) {
                return;
            }
            //#endregion Validar Almacenes a nivel línea

            //#region Validar Almacén a nivel cabecera
            const currentWhs = wareHouses?.find(whs => whs.WhsCode === newOrderModel?.Warehouse) ?? {};
            if (currentWhs?.WhsCode && currentWhs?.U_RS_TipoAlmacen === '008') {

                let WhsByLines = ''; // Almacén mas repetido a comparar con el de cabecera
                const warehouseCount = {};

                for (const line of newOrderModel?.ProductionOrderLines || []) {
                    if (Number(line?.ItemType ?? 4) !== -18 && line?.Warehouse) {
                        warehouseCount[line.Warehouse] = (warehouseCount[line.Warehouse] || 0) + 1;
                    }
                }

                //#region Obtener el warehouse más repetido
                let maxCount = 0;
                for (const whs in warehouseCount) {
                    if (warehouseCount[whs] > maxCount) {
                        maxCount = warehouseCount[whs];
                        WhsByLines = whs;
                    }
                }
                //#endregion Obtener el warehouse más repetido
                if (WhsByLines && newOrderModel?.Warehouse) {
                    const headerWhs = String(newOrderModel.Warehouse ?? '');
                    const lineWhs = String(WhsByLines ?? '');

                    const first3Match = headerWhs?.substring(0, 3) === lineWhs?.substring(0, 3);
                    const first2Match = headerWhs?.substring(0, 2) === lineWhs?.substring(0, 2);

                    validWhs = first3Match || first2Match;
                }
                if (!validWhs) {
                    showAlert({ type: 'error', message: `Es necesario validar el almacén de producto terminado ya que no coincide con el de las líneas`, timeOut: 5000 });
                    return;
                }
            }
            //#endregion Validar Almacén a nivel cabecera
        }
        if (newOrderModel.OriginDocumentCreate === 'rscMasterData') {
            if (!newOrderModel.Code) { return showAlert({ type: "warning", message: "Ingrese un valor valido para el código del Recurso" }); }
            if (!newOrderModel.Type) { return showAlert({ type: "warning", message: "Ingrese un valor valido para el tipo del Recurso" }); }
            if (!newOrderModel.Group) { return showAlert({ type: "warning", message: "Ingrese un valor valido para el grupo del Recurso" }); }
            if (!Number(newOrderModel.UnitsPerTime || 0)) { return showAlert({ type: "warning", message: "Ingrese un valor valido para las unidades por periodo del Recurso" }); }
            if (newOrderModel.Active === "N" && newOrderModel.Inactive === "N") { return showAlert({ type: "warning", message: "Seleccione un status valido para el recurso" }); }
        }

        return true
    }

    sendModel = () => {
        const { sendModelToCreateDocument, newOrderModel } = this.props
        if (this.validateList()) {
            sendModelToCreateDocument(newOrderModel)
        }
    }

    updateProvConfAssist = () => {
        // Ejecutar esto despues de las validaciones necesarias y creacion de documentos
        // asegurarse que el usuario este en la pestaña 5
        // Preferible deshabilitar el boton crear despues de una respuesta
        for (let i = 0; i <= 4; i++) {
            const element = document.getElementById(`nav-tab-${i}`);
            if (element) element.classList.add('disabled');
            if (i === 4) {
                element.classList.remove('active');
                document.getElementById('tab-4').classList.remove('active', 'show');
            }
        }
        this.refProvConfAssistant.state.activeTab = 5;
        document.getElementById('nav-tab-5').classList.add('active');
        document.getElementById('tab-5').classList.add('active', 'show')
    }

    openSelectionCriteriaModal = async () => {
        await this.getPartnerGroups();
        $('#SelectionCriteriaModal').modal('show');
    }

    getPartnerGroups = async () => {
        const { enableSpinner, newOrderModel, refreshModel } = this.props;

        enableSpinner(true);
        const listGroup = await apiClient.getGroupCode();
        newOrderModel.PartnerGroups = listGroup.status ? listGroup.data : [];
        refreshModel(newOrderModel);
        enableSpinner(false);
    };

    actionProperties = async (action) => {
        const { view, enableSpinner, showAlert, newOrderModel, refreshModel } = this.props;
        let table = '';
        let nameProperties = '';

        if (action) {
            if (view === 'provConfAssistant') {
                nameProperties = 'PartnerProperties';
                table = 'OCQG';
            }

            enableSpinner(true);
            const properties = await apiClient.getProperties(table);
            enableSpinner(false);

            if (properties.status === 1) {
                newOrderModel[nameProperties] = properties.data;
                refreshModel(newOrderModel);
                $('#PropertiesModal').modal('show');
            } else {
                showAlert({ type: 'error', message: properties.message });
            }

        } else {
            $('#PropertiesModal').modal('hide');
        }
    }

    renderContentRscMasterData = (render) => {
        const { newOrderModel, refreshModel, action, editMode, showAlert, enableSpinner } = this.props;
        return (
            <>
                <ContentRscMasterData
                    render={render}
                    model={newOrderModel}
                    refreshModel={refreshModel}
                    action={action}
                    editMode={editMode}
                    showAlert={showAlert}
                    enableSpinner={enableSpinner} />
            </>
        );
    }

    renderContentRscCapacity = (render) => {
        const { newOrderModel, action, enableSpinner } = this.props;
        return (
            <ContentRscCapacity
                render={render}
                newOrderModel={newOrderModel}
                action={action}
                enableSpinner={enableSpinner}
                openPropertiesModal={this.actionProperties}
            />
        );
    }

    renderSelectionCriteriaModal = () => {
        const { view, newOrderModel, refreshModel } = this.props;
        const views = ['provConfAssistant', 'rscCapacity'];

        if (views.includes(view)) {
            return (
                <SelectionCriteriaModal
                    view={view}
                    openPartner={this.openPartner}
                    newOrderModel={newOrderModel}
                    refreshModel={refreshModel}
                    getPartnerGroups={this.getPartnerGroups}
                    actionProperties={this.actionProperties}
                    partnersForAssistant={this.partnersForAssistant}
                />
            );
        }
    }

    partnersForAssistant = async () => {
        const { enableSpinner, showAlert, newOrderModel } = this.props;
        const { Client, Client2, PartnerGroup } = newOrderModel;

        if (Client && Client2) {
            if (Client?.ID >= Client2?.ID) return showAlert({ type: 'error', message: 'Su selección es invalida' });
        }

        const data = {
            action: 1,
            params: {
                PartnerGroup,
                ObjType: this.refProvConfAssistant.state.BaseDocument || '',
                CustomerCode: newOrderModel.CustomerCode,
                CustomerCode2: newOrderModel.CustomerCode2,
            }
        };

        enableSpinner(true);
        const partners = await apiClient.recordsForAssistant(data);
        enableSpinner(false);
        if (partners.status === 1) {
            if (partners.data.length < 1 || !this.refProvConfAssistant) return showAlert({ type: 'error', message: 'No hay socios que cumplan con los requisitos necesarios' });
            const selectPartners = partners.data.map(partner => ({ ...partner, checked: false }));

            this.refProvConfAssistant.setState({ partners: selectPartners });
            $('#SelectionCriteriaModal').modal('hide');
        } else {
            showAlert({ type: 'error', message: partners.message });
        }
    }

    openCentroCoste = async (index, centro) => {
        const { showAlert, enableSpinner } = this.props;
        enableSpinner(true);
        let getCentroCosteResponse = await apiClient.getCentroCosteList(centro);
        enableSpinner(false);

        if (!Array.isArray(getCentroCosteResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getCentroCosteResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            centroCostes: getCentroCosteResponse.data,
            lineIndex: index,
            centroCosteId: centro,
        }, () => {
            $('#CentroCoste').modal('show');
        });
    };

    selectCentroCoste = action => {
        const { centroCostes, lineIndex, centroCosteId } = this.state;
        const { newOrderModel, refreshModel } = this.props;
        let centroCoste = centroCostes[action.index];
        const { OcrCode = '', OcrName = '' } = centroCoste ?? {};
        const isProductionOrder = newOrderModel?.OriginDocumentCreate === 'productionOrder';
        const isProductTree = newOrderModel.OriginDocumentCreate === 'productTree';

        switch (centroCosteId) {
            case 1:
                if (isProductionOrder) {
                    newOrderModel.ProductionOrderLines[lineIndex].OcrCode = OcrCode || '';
                    newOrderModel.ProductionOrderLines[lineIndex].OcrName = OcrName || '';
                } else if (isProductTree) {
                    newOrderModel.ProductTreeLines[lineIndex].OcrCode = OcrCode || '';
                    newOrderModel.ProductTreeLines[lineIndex].OcrName = OcrName || '';
                } else {
                    newOrderModel.DocumentLines[lineIndex].OcrCode = OcrCode || '';
                    newOrderModel.DocumentLines[lineIndex].OcrName = OcrName || '';
                }

                break;
            case 2:
                if (isProductionOrder) {
                    newOrderModel.ProductionOrderLines[lineIndex].OcrCode2 = OcrCode || '';
                    newOrderModel.ProductionOrderLines[lineIndex].OcrName2 = OcrName || '';
                } else if (isProductTree) {
                    newOrderModel.ProductTreeLines[lineIndex].OcrCode2 = OcrCode || '';
                    newOrderModel.ProductTreeLines[lineIndex].OcrName2 = OcrName || '';
                } else {
                    newOrderModel.DocumentLines[lineIndex].OcrCode2 = OcrCode || '';
                    newOrderModel.DocumentLines[lineIndex].OcrName2 = OcrName || '';
                }

                break;
            case 3:
                if (isProductionOrder) {
                    newOrderModel.ProductionOrderLines[lineIndex].OcrCode3 = OcrCode || '';
                    newOrderModel.ProductionOrderLines[lineIndex].OcrName3 = OcrName || '';
                } else if (isProductTree) {
                    newOrderModel.ProductTreeLines[lineIndex].OcrCode3 = OcrCode || '';
                    newOrderModel.ProductTreeLines[lineIndex].OcrName3 = OcrName || '';
                } else {
                    newOrderModel.DocumentLines[lineIndex].OcrCode3 = OcrCode || '';
                    newOrderModel.DocumentLines[lineIndex].OcrName3 = OcrName || '';
                }

                break;
            case 4:
                if (isProductionOrder) {
                    newOrderModel.ProductionOrderLines[lineIndex].OcrCode4 = OcrCode || '';
                    newOrderModel.ProductionOrderLines[lineIndex].OcrName4 = OcrName || '';
                } else if (isProductTree) {
                    newOrderModel.ProductTreeLines[lineIndex].OcrCode4 = OcrCode || '';
                    newOrderModel.ProductTreeLines[lineIndex].OcrName4 = OcrName || '';
                } else {
                    newOrderModel.DocumentLines[lineIndex].OcrCode4 = OcrCode || '';
                    newOrderModel.DocumentLines[lineIndex].OcrName4 = OcrName || '';
                }

                break;
            case 5:
                if (isProductionOrder) {
                    newOrderModel.ProductionOrderLines[lineIndex].OcrCode5 = OcrCode || '';
                    newOrderModel.ProductionOrderLines[lineIndex].OcrName5 = OcrName || '';
                } else if (isProductTree) {
                    newOrderModel.ProductTreeLines[lineIndex].OcrCode5 = OcrCode || '';
                    newOrderModel.ProductTreeLines[lineIndex].OcrName5 = OcrName || '';
                } else {
                    newOrderModel.DocumentLines[lineIndex].OcrCode5 = OcrCode || '';
                    newOrderModel.DocumentLines[lineIndex].OcrName5 = OcrName || '';
                }

                break;
            default:
        }

        refreshModel(newOrderModel);
        $('#CentroCoste').modal('hide');
        setTimeout(() => {
            this.setState({
                centroCostes: [],
            });
        }, 100);
    };

    render() {
        const { items, pageTotal, type, partners, partnerType, indexPurchaseRequest, users, series, centroCostes } = this.state
        const { CloseDocumentModal, writeAccess, view, showAlert, newOrderModel, editMode } = this.props;
        const action = Number(this.props.action || 2);
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="DocumentCreateModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ zIndex: 90 }}>

                <ConfirmModal
                    CloseDocumentModal={CloseDocumentModal} />

                <ItemsListModal
                    data={items}
                    totalPage={pageTotal}
                    newOrderModel={newOrderModel}
                    mainView={view}
                    selectItems={this.selectItems}
                    cleanData={() => this.setState({ items: [] })}
                    refreshItems={this.refreshItems}
                    showAlert={showAlert}
                    typeSearch={type} />

                <ListMaterialModal
                    data={items}
                    totalPage={pageTotal}
                    newOrderModel={newOrderModel}
                    mainView={view}
                    selectItems={this.selectListMaterial}
                    cleanData={() => this.setState({ items: [] })}
                    refreshItems={this.refreshItems}
                    showAlert={showAlert}
                    typeSearch={type} />

                <UsersModal
                    data={users}
                    selectUser={this.selectUser}
                    cleanData={() => this.setState({ users: [] })} />

                {this.renderSelectionCriteriaModal()}

                <PartnerCreateModal
                    data={partners}
                    type={partnerType}
                    totalPage={pageTotal}
                    newOrderModel={newOrderModel}
                    selectPartner={this.selectPartner}
                    cleanData={() => this.setState({ partners: [] })}
                    refreshPartner={this.refreshPartner}
                    indexPurchaseRequest={indexPurchaseRequest} />

                <SeriesCreateModal
                    data={series}
                    selectSerie={this.selectSeries}
                    cleanData={() => this.setState({ series: [] })}
                />

                <CentroCosteModal
                    data={centroCostes}
                    selectCentroCoste={this.selectCentroCoste}
                    cleanData={() => this.setState({ centroCostes: [] })}
                />

                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content" id="printThis">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                {this.renderTitleModal()}
                            </h4>
                            <button type="button" className="close" onClick={this.closeModalCreate} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        {this.renderOptions()}
                                        {this.renderContentColumnCreate()}
                                        {this.renderPartidasColumnCreate()}
                                        {this.renderContentColumnTwoCreate()}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            {action === 2 && editMode && (
                                <>
                                    <button type="button" className="btn botonCerrar" onClick={this.cancelEditMode}>
                                        Cancelar
                                    </button>
                                    <button type="button" className="btn botonCorrect" onClick={this.sendModel}>
                                        Guardar
                                    </button>
                                </>
                            )}
                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModalCreate}>
                                Cerrar
                            </button>

                            {view === 'productionOrder' && Number(action) === 2 && !editMode &&
                                <select name="select" className="btn botonCorrect text-white copiarAA" value={''} onChange={(event) => this.props.CopyToDoc(event.target.value)}>
                                    <option value={this.props.copyTo}>Copiar a ...</option>
                                    {(newOrderModel.FlagCreateGoodIssue) && <option value="goodsIssue">Emisión de producción</option>}
                                    {(newOrderModel.FlagCreateGoodsReceiptProd) && <option value="goodsReceiptProd">Recibo de producción</option>}

                                </select>

                            }

                            {view === 'productionOrder' && Number(action) === 2 && !editMode &&
                                <button type="button" className="btn botonCorrect text-black" onClick={() => this.props.DuplicateDoc(view)}>
                                    Duplicar
                                </button>
                            }

                            {(action === 1 && writeAccess && view !== 'provConfAssistant') && (
                                <button type="button" className="btn botonCorrect text-black" onClick={this.sendModel}>
                                    Crear
                                </button>
                            )}

                        </div>
                    </div>
                </div>

                {this.openAction()}
            </div>
        );
    }
}

export default NewDocCreateModal;